// extracted by mini-css-extract-plugin
export default {"snowball-cta":"eYMd0","snowball-cta__inner":"uhPR7","snowball-cta__title":"wlAme","snowball-cta__description":"aBdtl","snowball-cta__note":"tz9CH"};